module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-thumb.fd1b6166.jpg";